import * as Yup from 'yup';

export const supportYupValidation = () => {
  return Yup.object().shape({
    email: Yup.string().required('required').email('incorrectEmail'),
    question: Yup.string().required('required'),
  });
};
